import httpClient from "@/api/http-client";
import type { IResponse } from "@/api/types/general-types";
import type { ISetupResponse } from "@/api/types/setup-types";
import { getApiBasePath } from "@/utils/request-utils";

export function getSetup(): Promise<IResponse<ISetupResponse>> {
  return httpClient.get(`${getApiBasePath()}/setup`);
}
